const getSanitizedName = name => name.replace(/['"-]/g, ' ')

export default getSanitizedName
